module.exports = __webpack_public_path__ + "media/images/brand/people04-0444f1a2d1d788dfd8c6d990e87a8dcc.png";